import React from 'react'
import { useTranslations } from 'next-intl'

import { WalletEmptyState } from './walletEmptyState'

const WalletEmptyStateWrapper: React.FC = () => {
    const t = useTranslations('wallet')

    return <WalletEmptyState title={t('noActivityYet')} message={t('noActivityMessage')} />
}

export { WalletEmptyStateWrapper }
export default WalletEmptyStateWrapper
